export const PREVIEW_OPEN_EVENT = 'shine:preview-open';
export function registerPreviewOpenContract(eventTarget) {
    let popup = null;
    let openPending = false;
    eventTarget.addEventListener(PREVIEW_OPEN_EVENT, () => {
        if (!popup) {
            openPending = true;
            return;
        }
        void popup.openForPreview();
    });
    return (nextPopup) => {
        popup = nextPopup;
        if (!openPending) {
            return;
        }
        openPending = false;
        void popup.openForPreview();
    };
}
